/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import moment from 'moment';
import {Row, Col, Box} from 'adminlte-2-react';
import {Alert} from '../utils/Alert';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import {Content} from '../ui/Content';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Etiqueta from '../utils/etiquetaObligatorio/Etiqueta';
import {getDateAtMidnight, getMidnightUTC} from '../utils/utils';
const {TextInput} = require('../utils/TextInput');

export const FeriadoCreateView = ({
  history,
  feriadoCreate,
  submit,
  submitAlert,
  topAlert,
  nombre,
  setNombre,
  fecha,
  setFecha,
}) => {
  const title = 'Crear feriado';

  return (
    <Content title={title} history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      <Row>
        <Col md="10" mdOffset="1">
          <Box title="Datos del feriado">
            <Row>
              <Col md="12">
                <TextInput
                  label="Nombre"
                  initialValue={nombre}
                  setValue={setNombre}
                  required
                />

                <div style={{marginBottom: 10}}>
                  <label>
                    <Etiqueta texto={'Fecha'} obligatorio={true} />
                  </label>
                  <DatePicker
                    customInput={<input type="text" className="form-control" />}
                    selected={fecha}
                    onChange={date => {
                      setFecha(date);
                    }}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </Col>

              <Col md="12">
                {submitAlert.text && (
                  <Alert
                    title={submitAlert.title}
                    type={submitAlert.type}
                    text={submitAlert.text}
                    closable={submitAlert.closable}
                  />
                )}
                <ButtonWithLoading
                  text="Guardar"
                  submit={submit}
                  loading={feriadoCreate.loading}
                  pullRight
                />
              </Col>
            </Row>
          </Box>
        </Col>
      </Row>
    </Content>
  );
};
